module.exports = __webpack_public_path__ + "static/media/ic-roomservice.1c6dad02.svg";